var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviewingNow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.01052C0 3.32298 2.947 0 7.014 0C10.99 0 14 3.25989 14 6.98948C14 11.315 10.472 14 7 14C5.852 14 4.578 13.6915 3.556 13.0886C3.199 12.8713 2.898 12.7101 2.513 12.8363L1.099 13.2569C0.742 13.3691 0.42 13.0886 0.525 12.7101L0.994 11.1397C1.071 10.9224 1.057 10.691 0.945 10.5088C0.343 9.4011 0 8.18828 0 7.01052ZM3.75889 7.91491C3.26889 7.91491 2.86289 7.5083 2.86289 7.01756C2.86289 6.51981 3.26189 6.12021 3.75889 6.12021C4.25589 6.12021 4.65489 6.51981 4.65489 7.01756C4.65489 7.5083 4.25589 7.9079 3.75889 7.91491ZM6.08906 7.01074C6.08906 7.50848 6.48806 7.90808 6.98506 7.91509C7.48206 7.91509 7.88106 7.50848 7.88106 7.01775C7.88106 6.52 7.48206 6.1204 6.98506 6.1204C6.49506 6.11339 6.08906 6.52 6.08906 7.01074ZM9.31563 7.01766C9.31563 7.5084 9.71463 7.91501 10.2116 7.91501C10.7086 7.91501 11.1076 7.5084 11.1076 7.01766C11.1076 6.51991 10.7086 6.12031 10.2116 6.12031C9.71463 6.12031 9.31563 6.51991 9.31563 7.01766Z",
    fill: "#DD6363"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewingNow);
export default __webpack_public_path__ + "static/media/interviewingNow.ca69a656.svg";
export { ForwardRef as ReactComponent };